import { IUser } from './Iuser';
import { UserMapper } from './mapper';
/**
 * iterate through the user result response and crate a model with help of mapper class
 * @param   {array} data search api response
 */
export class UserModel {
  userData: Array<IUser> = [];
  
  constructor(userData: any = []) {
    if (userData) {
      const transModel = new UserMapper(userData);
      this.userData.push(transModel.user);
    }
  }
}